import { clearTechniqueFeedbackValues } from "domain/ai-search/ai-search.actions";
import {
  ActivitiesPageFilters,
  DurationFilter,
} from "domain/entities/activities.entities";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch } from "ui/hook/store";
import { Technique } from "ui/pages/app/techniques/technique/Technique";
import { Techniques } from "ui/pages/app/techniques/Techniques";

export function TechniquesContainer() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const [flippedCards, setFlippedCards] = useState<number[]>([]);
  const minDuration = 0;
  const maxDuration = 180;
  const [filters, setFilters] = useState<
    ActivitiesPageFilters & {
      [key: string]: string[] | string | boolean | number | DurationFilter;
    }
  >({
    contexts: [],
    types: [],
    techObjectives: [],
    participants: "",
    modalities: [],
    duration: {
      $gte: minDuration,
      $lte: maxDuration,
    },
    level: [],
  });

  useEffect(() => {
    return () => {
      dispatch(clearTechniqueFeedbackValues());
    };
  }, []); //eslint-disable-line

  return searchParams.get("id") ? (
    <Technique selectedTechniqueId={searchParams.get("id")} />
  ) : (
    <Techniques
      filters={filters}
      setFilters={setFilters}
      minDuration={minDuration}
      maxDuration={maxDuration}
      flippedCards={flippedCards}
      setFlippedCards={setFlippedCards}
    />
  );
}
